import styles from "./Targeting.module.scss"
import Checkbox from "../../../../../components/common/Checkbox/Checkbox"

const Targeting = ({ checkboxState, handleCheckboxChange }) => {  

  const names = Object.keys(checkboxState)

  return (
    <div>
      <div className={styles["heading"]}>Targeting</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <div>Select preferred targeting option</div>

          <div className="px-3">
            <div className="d-flex gap-2">
              <div className="mt-1">
                <Checkbox name={names[0]} checked={checkboxState.automatic} onChange={handleCheckboxChange} />
              </div>
              <div>
                <div>Viewers of product detail pages</div>
              </div>
            </div>
            <div className="d-flex gap-2">
              <div className="mt-1">
                <Checkbox name={names[1]} checked={checkboxState.manual} onChange={handleCheckboxChange} />
              </div>
              <div>
                <div>Similar product audiences</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Targeting
